<template>
  <v-row class="ma-0">
    <v-col class="py-1 pb-10 px-6">
      <p class="policy-desc">
        &lt;주식회사 이수시스템&gt;('https://www.workup.plus/'이하
        'WORKUP')은(는) 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를
        보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기
        위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
      </p>
      <!-- 1조 시작 -->
      <p class="policy-title mt-6">제1조(개인정보의 처리목적)</p>
      <p class="policy-desc mt-3">
        &lt;주식회사 이수시스템&gt;(이)가 개인정보 보호법 제32조에 따라 등록,
        공개하는 개인정보파일의 처리목적은 다음과 같습니다.
      </p>
      <p class="policy-desc mt-3">
        처리하는 개인정보 항목 : &lt;주식회사 이수시스템&gt;은 다음의 개인정보
        항목을 처리하고 있습니다.
      </p>
      <ul class="list-common mt-3 pl-5">
        <li>
          - 성명, 생년월일, 주소, 전화번호, 이메일주소, 신용카드번호, 은행
          계좌정보 등
        </li>
      </ul>
      <p class="policy-desc mt-3">
        개인정보의 처리목적: 회사는 다음의 목적 을 위하여 개인정보를 처리합니다.
        처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,
        이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의
        동의를 받는 등 필요한 조치를 이행할 예정입니다.
      </p>
      <ol class="list-common number-list">
        <li>
          <span>회원 가입 및 관리</span>
          <div class="policy-desc mt-3">
            회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별∙인증,
            회원자격 유지∙관리, 서비스 부정이용 방지, 만 14세 미만 아동의
            개인정보 처리 시 법정대리인의 동의 여부 확인, 각종 고지∙통지,
            고충처리 목적으로 개인정보를 처리합니다.
          </div>
        </li>
        <li>
          <span>클라우드 HR솔루션 서비스 제공</span>
          <div class="policy-desc mt-3">
            인사/조직 관리, 급여 관리, 근태관리, 채용관리, 평가관리 등 클라우드
            HR솔루션 서비스 제공, 콘텐츠 제공, 맞춤서비스 제공, 본인인증,
            연령인증의 목적으로 개인정보를 처리합니다.
          </div>
          <div class="policy-desc mt-3">
            수집방법: 홈페이지, 서면양식, 전화/팩스, 경품행사, 배송요청,
            제휴사로부터 제공받음, 생성정보 수집 툴을 통한 수집
          </div>
          <div class="policy-desc mt-3">
            보유기간: &lt;주식회사 이수시스템&gt;은 법령에 따른 개인정보
            보유기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보
            보유기간 내에서 개인정보를 처리∙보유합니다.
          </div>
          <div class="policy-desc mt-3">
            각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
          </div>
          <ol class="list-common number-list">
            <li>
              회원 가입 및 관리: 홈페이지 탈퇴 시까지, 다만 다음의 사유에
              해당하는 경우에는 해당 사유 종료시까지
              <ol class="list-common number-list bracket">
                <li>
                  관계 법령 위반에 따른 수사∙조사 등이 진행 중인 경우에는 해당
                  수사∙조사 종료 시까지
                </li>
                <li>
                  홈페이지 이용에 따른 채권∙채무관계 잔존 시에는 해당
                  채권∙채무관계 정산 시까지
                </li>
              </ol>
            </li>
            <li>
              서비스 제공: 서비스 공급완료 및 요금결제∙정산 완료 시까지
              <p class="policy-desc">
                다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지
              </p>
              <ol class="list-common number-list bracket">
                <li>
                  전자상거래 등에서의 소비자 보호에 관한 법률에 따른 표시∙광고,
                  계약내용 및 이행 등 거래에 관한 기록
                  <ul class="list-common dash-list type2">
                    <li>표시∙광고에 관한 기록: 6개월,</li>
                    <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년,</li>
                    <li>대금결제 및 재화 등의 공급에 관한 기록: 5년,</li>
                    <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
                  </ul>
                </li>
                <li>
                  신용정보의 이용 및 보호에 관한 법률에 따른 신용정보
                  업무처리기록
                  <ul class="list-common dash-list type2">
                    <li>신용정보의 수집/처리 및 이용 등에 관한 기록: 3년</li>
                  </ul>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
      <!-- 1조 끝 -->
      <!-- 2조 시작 -->
      <p class="policy-title mt-6">제2조(개인 정보 제3자 제공)</p>
      <ol class="list-common number-list">
        <li>
          공급사업자는 원칙적으로 “개인정보의 수집 및 이용”에서 고지한 범위
          내에서 개인정보를 이용하거나 제3자에게 제공하며, 동 범위를 초과하여
          이용하거나 제3자에게 제공하지 않습니다. 다만, 다음 사항은 예외적으로
          동의 없이 개인정보 제공이 가능합니다.
          <ol class="list-common number-list bracket">
            <li>최종이용자가 사전에 동의한 경우</li>
            <li>
              법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진 절차와
              방법에 따라 수사기관 및 감독당국의 요구가 있는 경우
            </li>
            <li>요금 정산을 위하여 필요한 경우</li>
            <li>
              최종이용자 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여
              필요함에도 불구하고 동의를 받을 수 없는 경우
            </li>
          </ol>
        </li>
        <li>
          제3자 제공 현황은 아래와 같습니다.
          <ul class="list-common dot-list">
            <li>
              제공받는 자<br />
              <span class="pl-3"
                >이용사업자 및 이용사업자가 권한을 부여한 최종이용자</span
              >
            </li>
            <li>
              제공받는 자의 목적<br />
              <span class="pl-3">워크업 서비스 내 프로필 열람</span><br />
              <span class="pl-3"> (관리자의 경우 열람 및 관리)</span>
            </li>
            <li>
              제공 항목<br />
              <span class="pl-3"
                >성명, 이메일, 전화번호(선택), 위치정보(선택)</span
              >
            </li>
            <li>
              제공받는 자의 보유기간<br />
              <span class="pl-3">회사 삭제 시까지</span>
            </li>
          </ul>
        </li>
      </ol>
      <!-- 2조 끝 -->
      <!-- 3조 시작 -->
      <p class="policy-title mt-6">제3조(개인정보처리의 위탁 에 관한 사항)</p>
      <ol class="list-common number-list">
        <li>
          &lt;주식회사 이수시스템&gt;은(는) 원활한 개인정보 업무처리를 위하여
          다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
          <div class="table-wrap mt-4">
            <table class="policy-table">
              <colgroup>
                <col width="" />
                <col width="" />
              </colgroup>
              <thead>
                <tr>
                  <th>수탁사</th>
                  <th>위탁업무</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>채널톡</td>
                  <td>
                    채팅, 전화를 이용한 고객 상담 업무도입, 기타문의 상담 업무
                  </td>
                </tr>
                <tr>
                  <td>(주)아임포트, 나이스정보통신</td>
                  <td>이용요금 결제 처리</td>
                </tr>
                <tr>
                  <td>NCP</td>
                  <td>데이터 보관 및 인프라 관리</td>
                </tr>
                <tr>
                  <td>(주)모두싸인</td>
                  <td>전자계약 API 제공</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          &lt;주식회사 이수시스템&gt;은(는) 위탁계약 체결 시 「개인정보 보호법」
          제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적/관리적
          보호조치, 재 위탁 제한, 수탁자에 대한 관리/감독, 손해배상 등 책임에
          관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게
          처리하는지를 감독하고 있습니다.
        </li>
        <li>
          위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
          처리방침을 통하여 공개하도록 하겠습니다.
        </li>
      </ol>
      <!-- 3조 끝 -->
      <!-- 4조 시작 -->
      <p class="policy-title mt-6">제4조(개인정보의 파기절차 및 파기방법)</p>
      <ol class="list-common number-list">
        <li>
          &lt;주식회사 이수시스템&gt; 은(는) 개인정보 보유기간의 경과, 처리목적
          달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를
          파기합니다.
        </li>
        <li>
          정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리목적이
          달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야
          하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나
          보관장소를 달리하여 보존합니다.
        </li>
        <li>
          개인정보 파기의 절차 및 방법은 다음과 같습니다.
          <!-- 알파벳 리스트 -->
          <ul class="list-common alpha-list">
            <li>
              <span>파기절차</span>
              <p class="policy-desc mt-3">
                &LT;주식회사 이수시스템&GT; 은(는) 파기 사유가 발생한 개인정보를
                선정하고, &LT;주식회사 이수시스템&GT; 의 개인정보 보호책임자의
                승인을 받아 개인정보를 파기합니다.
              </p>
            </li>
            <li>
              <span>파기방법</span>
              <p class="policy-desc mt-3">
                전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을
                사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을
                통하여 파기합니다.
              </p>
            </li>
          </ul>
        </li>
      </ol>
      <!-- 4조 끝 -->
      <!-- 5조 시작 -->
      <p class="policy-title mt-6">
        제5조(정보주체와 법정대리인의 권리·의무 및 그 행사방법에 관한 사항)
      </p>
      <ol class="list-common number-list">
        <li>
          정보주체는 주식회사 이수시스템에 대해 언제든지 개인정보
          열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
        </li>
        <li>
          제1항에 따른 권리 행사는 주식회사 이수시스템에 대해 「개인정보
          보호법」 시행령 제41조 제1항에따라 서면, 전자우편, 모사전송(FAX) 등을
          통하여 하실 수 있으며 주식회사 이수시스템은(는) 이에 대해 지체 없이
          조치하겠습니다.
        </li>
        <li>
          제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
          대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리 방법에 관한
          고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
        </li>
        <li>
          개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항,
          제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.
        </li>
        <li>
          개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집
          대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
        </li>
        <li>
          주식회사 이수시스템은(는) 정보주체 권리에 따른 열람의 요구,
          정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나
          정당한 대리인인지를 확인합니다.
        </li>
      </ol>
      <!-- 5조 끝 -->
      <!-- 6조 시작 -->
      <p class="policy-title mt-6">
        제6조(개인정보의 안전성 확보조치에 관한 사항)
      </p>
      <p class="policy-desc mt-4">
        &LT;주식회사 이수시스템&GT;은(는) 개인정보의 안전성 확보를 위해 다음과
        같은 조치를 취하고 있습니다.
      </p>
      <ol class="list-common number-list">
        <li>
          <span>정기적인 자체 감사 실시</span>
          <p class="policy-desc mt-3">
            개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체
            감사를 실시하고 있습니다.
          </p>
        </li>
        <li>
          <span>개인정보 취급 직원의 최소화 및 교육</span>
          <p class="policy-desc mt-3">
            개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여
            개인정보를 관리하는 대책을 시행하고 있습니다.
          </p>
        </li>
        <li>
          <span>내부관리계획의 수립 및 시행</span>
          <p class="policy-desc mt-3">
            개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고
            있습니다.
          </p>
        </li>
        <li>
          <span>해킹 등에 대비한 기술적 대책</span>
          <p class="policy-desc mt-3">
            &LT;주식회사 이수시스템&GT;('WORKUP')은 해킹이나 컴퓨터 바이러스
            등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을
            설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에
            시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
          </p>
        </li>
        <li>
          <span>개인정보의 암호화</span>
          <p class="policy-desc mt-3">
            이용자의 개인정보는 비밀번호는 암호화되어 저장 및 관리되고 있어,
            본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를
            암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고
            있습니다.
          </p>
        </li>
        <li>
          <span>접속기록의 보관 및 위/변조 방지</span>
          <p class="policy-desc mt-3">
            개인정보처리시스템에 접속한 기록을 최소 1년 이상 보관, 관리하고
            있으며, 다만, 5만명 이상의 정보주체에 관하여 개인정보를 추가하거나,
            고유식별정보 또는 민감정보를 처리하는 경우에는 2년이상 보관,
            관리하고 있습니다. 또한, 접속기록이 위/변조 및 도난, 분실되지 않도록
            보안기능을 사용하고 있습니다.
          </p>
        </li>
        <li>
          <span>개인정보에 대한 접근 제한</span>
          <p class="policy-desc mt-3">
            개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경,
            말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고
            있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
            있습니다.
          </p>
        </li>
        <li>
          <span>문서보안을 위한 잠금장치 사용</span>
          <p class="policy-desc mt-3">
            개인정보가 포함된 서류, 보조저장매체 등을 잠금 장치가 있는 안전한
            장소에 보관하고 있습니다.
          </p>
        </li>
        <li>
          <span>비인가자에 대한 출입 통제</span>
          <p class="policy-desc">
            개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해
            출입통제 절차를 수립, 운영하고 있습니다.
          </p>
        </li>
      </ol>
      <!-- 6조 끝 -->
      <!-- 7조 시작 -->
      <p class="policy-desc mt-4">
        제7조(개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한
        사항)
      </p>
      <ol class="list-common number-list">
        <li>
          주식회사 이수시스템 은(는) 이용자에게 개별적인 맞춤서비스를 제공하기
          위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
        </li>
        <li>
          쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터
          브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의
          하드디스크에 저장되기도 합니다.
          <ul class="list-common alpha-list">
            <li>
              쿠키의 사용 목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한
              방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여
              이용자에게 최적화된 정보 제공을 위해 사용됩니다.
            </li>
            <li>
              쿠키의 설치•운영 및 거부: 웹 브라우저 상단의 도구>인터넷
              옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수
              있습니다.
            </li>
            <li>
              쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수
              있습니다.
            </li>
          </ul>
        </li>
        <li>
          이외에 주식회사 이수시스템은 온라인 맞춤형 광고 등을 위한 행태정보를
          수집∙이용∙제공하지 않습니다.
        </li>
      </ol>
      <!-- 7조 끝 -->
      <!-- 8조 시작 -->
      <p class="policy-title mt-6">제8조 (개인정보 보호책임자에 관한 사항)</p>
      <ol class="list-common number-list">
        <li>
          주식회사 이수시스템 은(는) 개인정보 처리에 관한 업무를 총괄해서
          책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
          위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          <div class="plicy-desc mt-3">
            개인정보 보호책임자
            <ul class="list-common dot-list">
              <li>성명: 김명준</li>
              <li>직책: 팀장</li>
              <li>연락처: 02-6494-2947</li>
              <li>E-mail: sys_kmj@isu.co.kr</li>
            </ul>
          </div>
        </li>
        <li>
          정보주체께서는 주식회사 이수시스템의 서비스(또는 사업)을 이용하시면서
          발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한
          사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 주식회사
          이수시스템은 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴
          것입니다.
        </li>
      </ol>
      <!-- 8조 끝 -->
      <!-- 9조 시작 -->
      <p class="policy-title mt-6">
        제9조(정보주체의 권익침해에 대한 구제방법)
      </p>
      <p class="policy-desc mt-4">
        정보주체는 개인정보침해로 인한 구제를 받기 위하여
        개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에
        분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의
        신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
      </p>
      <ol class="list-common number-list">
        <li>
          개인정보분쟁조정위원회: (국번없이) 1833-6972<br />
          (www.kopico.go.kr)
        </li>
        <li>
          개인정보침해신고센터: (국번없이) 118<br />
          (privacy.kisa.or.kr)
        </li>
        <li>
          대검찰청: (국번없이) 1301<br />
          (www.spo.go.kr)
        </li>
        <li>
          경찰청: (국번없이) 182<br />
          (ecrm.cyber.go.kr)
        </li>
      </ol>
      <p class="policy-desc mt-4">
        「개인정보보호법」제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제),
        제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대 하여 공공기관의
        장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는
        행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
      </p>
      <p class="policy-desc mt-4">
        - 중앙행정심판위원회: (국번없이) 110 (www.simpan.go.kr)
      </p>
      <!-- 9조 끝 -->
      <!-- 10조 시작 -->
      <p class="policy-title mt-6">제10조(개인정보 처리방침 변경)</p>
      <p class="policy-desc mt-4">
        이 개인정보처리방침은 2023년 1월 1일부터 적용됩니다.
      </p>
      <!-- 10조 끝 -->
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style scoped></style>
